import { Link } from "react-router-dom";

const services = [
{
  number: "01",
  title: "Walt Disney World®",
  description:
  "Magic Kingdom®, EPCOT®, Hollywood Studios®, Animal Kingdom® — planned with precision. Dining reservations, Lightning Lane™ strategy, resort selection, and park-day sequencing all handled for you.",
  link: "/work-with-me",
  featured: true
},
{
  number: "02",
  title: "Disney Cruise Line®",
  description:
  "Stateroom selection, port excursions, onboard reservations — Disney cruises demand the same strategic depth as a Walt Disney World trip. Know exactly what to book and when.",
  link: "/work-with-me",
  featured: false
},
{
  number: "03",
  title: "Universal Orlando",
  description:
  "The Wizarding World, Epic Universe, and beyond. Solo or as a Disney add-on — I'll build the right itinerary either way.",
  link: "/work-with-me",
  featured: false
},
{
  number: "04",
  title: "All-Inclusive Resorts",
  description:
  "Sandals, Secrets, Dreams, Excellence — honest recommendations based on your family's priorities, not commissions.",
  link: "/work-with-me",
  featured: false
},
{
  number: "05",
  title: "Custom Vacations",
  description:
  "Honeymoons, milestones, group travel, multi-destination. If your dream trip doesn't fit a template, I build it from scratch.",
  link: "/work-with-me",
  featured: false
}];


export const IntroSection = () => {
  return (
    <section className="py-28 bg-secondary" id="destinations" aria-label="Our services">
      <div className="container mx-auto px-6">
        <div className="max-w-5xl mx-auto">

          {/* Header */}
          <div className="text-center mb-16">
            <div className="flex items-center justify-center gap-4 mb-5">
              <div className="h-px flex-1 max-w-[60px] bg-gradient-to-r from-transparent to-gold/40" />
              <p className="font-cinzel text-[0.6rem] text-gold tracking-[0.35em] uppercase">MY SPECIALTIES</p>
              <div className="h-px flex-1 max-w-[60px] bg-gradient-to-l from-transparent to-gold/40" />
            </div>
            <h2 className="font-serif font-light text-foreground mb-5"
            style={{ fontSize: "clamp(1.9rem, 4vw, 2.8rem)" }}>Where I Specialize

            </h2>
            <p className="text-muted-foreground max-w-xl mx-auto font-sans leading-relaxed">I plan the destinations where expertise actually changes the outcome — not just the booking.

            </p>
          </div>

          {/* Grid */}
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-5">

            {/* Disney Parks — Featured (spans 2 cols on lg) */}
            <Link
              to={services[0].link}
              className="group relative bg-card border border-border rounded-[3px] p-8 card-glow block lg:col-span-2 overflow-hidden">

              {/* Subtle gradient accent in corner */}
              <div className="absolute top-0 right-0 w-48 h-48 bg-gradient-radial from-gold/8 to-transparent rounded-full -translate-y-1/2 translate-x-1/2 pointer-events-none" />

              <div className="flex items-start justify-between mb-6">
                <span className="font-cinzel text-[0.55rem] text-gold tracking-[0.3em] uppercase">
                  {services[0].number} — Primary Specialty
                </span>
                <span className="font-cinzel text-[0.55rem] text-gold/50 tracking-[0.15em] uppercase border border-gold/20 px-2 py-0.5 rounded-[2px]">
                  Featured
                </span>
              </div>

              <h3 className="font-serif text-2xl font-light text-foreground mb-4 group-hover:text-gold transition-smooth">
                {services[0].title}
              </h3>
              <p className="text-muted-foreground leading-relaxed font-sans">
                {services[0].description}
              </p>
              <div className="mt-7 flex items-center gap-2 text-gold text-sm font-cinzel tracking-widest uppercase text-[0.6rem]">
                <span>Explore</span>
                <span className="transition-transform group-hover:translate-x-1.5 inline-block">→</span>
              </div>
            </Link>

            {/* Remaining services */}
            {services.slice(1).map((service, i) =>
            <Link
              key={service.number}
              to={service.link}
              className="group bg-card border border-border rounded-[3px] p-7 card-glow block animate-slide-up"
              style={{ animationDelay: `${(i + 1) * 0.07}s` }}>

                <span className="font-cinzel text-[0.55rem] text-gold/70 tracking-[0.3em] uppercase block mb-5">
                  {service.number}
                </span>
                <h3 className="font-serif text-lg font-light text-foreground mb-3 group-hover:text-gold transition-smooth">
                  {service.title}
                </h3>
                <p className="text-muted-foreground text-[0.85rem] leading-relaxed font-sans">
                  {service.description}
                </p>
              </Link>
            )}
          </div>
        </div>
      </div>
    </section>);

};